(function () {
  'use strict';
  if (window.__VSKLO_MOBILE_DRAWER_CANONICAL__) return;
  window.__VSKLO_MOBILE_DRAWER_CANONICAL__ = true;

  var root = document.documentElement;
  var mq = window.matchMedia
    ? window.matchMedia(window.VSKLOBreakpoints ? window.VSKLOBreakpoints.drawerQuery : '(max-width: 1366px)')
    : null;
  var closeTimer = 0;
  var lastTrigger = null;
  var boundDrawer = null;
  var boundOverlay = null;

  function list(scope, selector) {
    return scope && scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : [];
  }
  function one(scope, selector) {
    return scope && scope.querySelector ? scope.querySelector(selector) : null;
  }
  function drawerViewport() {
    return !mq || mq.matches;
  }
  function focusables(scope) {
    return list(scope, 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])').filter(function (el) {
      return el.tabIndex >= 0 && !el.hidden && el.getAttribute('aria-hidden') !== 'true' && !el.closest('[hidden]');
    });
  }

  function bindGlobalEvents() {
    if (window.__VSKLO_MOBILE_DRAWER_GLOBAL_EVENTS__) return;
    window.__VSKLO_MOBILE_DRAWER_GLOBAL_EVENTS__ = true;

    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest
        ? event.target.closest('[data-vsklo-mobile-drawer-open]')
        : null;
      if (!button || !drawerViewport()) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var liveDrawer = document.querySelector('[data-vsklo-mobile-drawer]');
      var bindingIsStale =
        !boundDrawer ||
        !boundDrawer.isConnected ||
        (liveDrawer && liveDrawer !== boundDrawer);

      if ((bindingIsStale || typeof window.VSKLOMobileDrawerSetOpen !== 'function') &&
          typeof window.VSKLOInitMobileDrawer === 'function') {
        window.VSKLOInitMobileDrawer();
      }

      if (typeof window.VSKLOMobileDrawerSetOpen === 'function') {
        var open = !root.classList.contains('vsklo-mobile-drawer-open');
        window.VSKLOMobileDrawerSetOpen(open, button);
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!root.classList.contains('vsklo-mobile-drawer-open')) return;
      var currentDrawer = document.querySelector('[data-vsklo-mobile-drawer]');
      if (!currentDrawer) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        if (typeof window.VSKLOMobileDrawerClose === 'function') window.VSKLOMobileDrawerClose();
        return;
      }

      if (event.key !== 'Tab') return;
      var items = focusables(currentDrawer);
      if (!items.length) {
        event.preventDefault();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (mq && mq.addEventListener) {
      mq.addEventListener('change', function () {
        if (typeof window.VSKLOMobileDrawerViewportChanged === 'function') {
          window.VSKLOMobileDrawerViewportChanged();
        }
      });
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(window.__vskloDrawerResizeTimer);
      window.__vskloDrawerResizeTimer = window.setTimeout(function () {
        if (typeof window.VSKLOMobileDrawerViewportChanged === 'function') {
          window.VSKLOMobileDrawerViewportChanged();
        }
      }, 80);
    }, { passive: true });

    window.addEventListener('orientationchange', function () {
      window.setTimeout(function () {
        if (typeof window.VSKLOMobileDrawerViewportChanged === 'function') {
          window.VSKLOMobileDrawerViewportChanged();
        }
      }, 100);
    }, { passive: true });
  }

  function cleanupDetachedBinding() {
    if (!boundDrawer) return;

    var staleDrawer = boundDrawer;
    var staleOverlay = boundOverlay;

    window.clearTimeout(closeTimer);
    closeTimer = 0;
    root.classList.remove('vsklo-mobile-drawer-open');
    if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('mobile-drawer');
    if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();

    list(document, '[data-vsklo-mobile-drawer-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });

    if (staleDrawer && staleDrawer.isConnected) {
      staleDrawer.hidden = true;
      staleDrawer.setAttribute('inert', '');
      staleDrawer.setAttribute('aria-hidden', 'true');
    }
    if (staleOverlay && staleOverlay.isConnected) {
      staleOverlay.hidden = true;
      staleOverlay.setAttribute('aria-hidden', 'true');
    }

    if (staleDrawer && typeof staleDrawer.__vskloCanonicalCleanup === 'function') {
      try { staleDrawer.__vskloCanonicalCleanup(); } catch (error) {}
    }

    boundDrawer = null;
    boundOverlay = null;
    lastTrigger = null;
  }

  function init() {
    if (boundDrawer && !boundDrawer.isConnected) cleanupDetachedBinding();

    var drawer = document.querySelector('[data-vsklo-mobile-drawer]');
    var overlay = document.querySelector('[data-vsklo-mobile-drawer-overlay]');
    if (!drawer || !overlay) return;

    if (drawer === boundDrawer && drawer.dataset.vskloCanonicalBound === 'true') return;
    if (boundDrawer && boundDrawer !== drawer) cleanupDetachedBinding();

    boundDrawer = drawer;
    boundOverlay = overlay;
    drawer.dataset.vskloCanonicalBound = 'true';

    var tabs = [];
    var panels = [];
    var innerBound = false;

    function headerBottom() {
      var header = document.querySelector('.section-header');
      if (!header || !header.getBoundingClientRect) return 0;
      var rect = header.getBoundingClientRect();
      return Math.max(0, Math.round(rect.bottom));
    }

    function syncTop() {
      if (!drawerViewport()) return;
      var top = headerBottom();
      if (top < 1) top = 102;
      root.style.setProperty('--vsklo-mobile-drawer-top', top + 'px');
    }

    function triggerState(open) {
      list(document, '[data-vsklo-mobile-drawer-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function activateTab(key, focus) {
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-vsklo-mobile-tab') === key;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
        if (active && focus) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-vsklo-mobile-panel') === key;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    }

    function resetDrawer() {
      if (!innerBound) return;
      if (tabs.length) activateTab(tabs[0].getAttribute('data-vsklo-mobile-tab'), false);
      list(drawer, '[data-vsklo-mobile-submenu-toggle]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      list(drawer, '.vsklo-mobile-drawer__sublist').forEach(function (submenu) {
        submenu.hidden = true;
      });
    }

    function hydrateDrawerContent() {
      if (innerBound) return true;

      var template = one(drawer, 'template[data-vsklo-mobile-drawer-template]');
      if (template && template.content) {
        drawer.appendChild(template.content.cloneNode(true));
        template.remove();
      }

      tabs = list(drawer, '[data-vsklo-mobile-tab]');
      panels = list(drawer, '[data-vsklo-mobile-panel]');
      // Both row text and the arrow may toggle one submenu. Link them to
      // the same actual list so assistive technology follows the live state.
      var submenuSequence = 0;
      list(drawer, '[data-vsklo-mobile-submenu-toggle]').forEach(function (button) {
        var row = button.closest('.vsklo-mobile-drawer__row');
        var parent = row ? row.parentElement : button.parentElement;
        var submenu = parent ? one(parent, ':scope > .vsklo-mobile-drawer__sublist') : null;
        if (!submenu) return;
        if (!submenu.id) {
          submenuSequence += 1;
          submenu.id = drawer.id + '-submenu-' + submenuSequence;
        }
        button.setAttribute('aria-controls', submenu.id);
      });
      innerBound = true;
      drawer.dataset.vskloDrawerHydrated = 'true';

      list(drawer, '[data-vsklo-mobile-drawer-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          setOpen(false);
        });
      });

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab.getAttribute('data-vsklo-mobile-tab'), false);
        });
        tab.addEventListener('keydown', function (event) {
          if (!/^(ArrowLeft|ArrowRight|Home|End)$/.test(event.key)) return;
          event.preventDefault();
          var next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activateTab(tabs[next].getAttribute('data-vsklo-mobile-tab'), true);
        });
      });

      list(drawer, '[data-vsklo-mobile-submenu-toggle]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var row = button.closest('.vsklo-mobile-drawer__row');
          var parent = row ? row.parentElement : button.parentElement;
          var submenu = parent ? one(parent, ':scope > .vsklo-mobile-drawer__sublist') : null;
          if (!submenu) return;
          var expanded = button.getAttribute('aria-expanded') === 'true';
          submenu.hidden = expanded;
          list(row, '[data-vsklo-mobile-submenu-toggle]').forEach(function (peer) {
            peer.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          });
        });
      });

      list(drawer, 'a[href]').forEach(function (link) {
        link.addEventListener('click', function () {
          setOpen(false);
        });
      });

      resetDrawer();
      return true;
    }

    function finalizeClosed() {
      if (root.classList.contains('vsklo-mobile-drawer-open')) return;
      drawer.hidden = true;
      overlay.hidden = true;
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      resetDrawer();

      if (lastTrigger && document.contains(lastTrigger)) {
        try { lastTrigger.focus(); } catch (error) {}
      }
      lastTrigger = null;
    }

    function setOpen(open, trigger) {
      window.clearTimeout(closeTimer);

      if (open) {
        if (!drawerViewport()) return;
        hydrateDrawerContent();

        if (typeof window.VSKLOCloseMobileSearch === 'function') {
          window.VSKLOCloseMobileSearch();
        }
        if (typeof window.VSKLOCloseDesktopSearch === 'function') {
          window.VSKLOCloseDesktopSearch(false, true);
        }
        var minicart = document.querySelector('cart-notification#minicart_wrapper, cart-drawer');
        if (minicart && typeof minicart.close === 'function') {
          minicart.close();
        }

        lastTrigger = trigger || document.activeElement;
        syncTop();
        drawer.hidden = false;
        overlay.hidden = false;
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');

        if (window.VSKLOOverlayState) window.VSKLOOverlayState.acquire('mobile-drawer');

        window.requestAnimationFrame(function () {
          root.classList.add('vsklo-mobile-drawer-open');
          triggerState(true);
          var first = focusables(drawer)[0];
          if (first) first.focus();
        });
        return;
      }

      root.classList.remove('vsklo-mobile-drawer-open');
      if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('mobile-drawer');
      if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
      triggerState(false);
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      closeTimer = window.setTimeout(finalizeClosed, 300);
    }

    function prepareClosedState() {
      root.classList.remove('vsklo-mobile-drawer-open');
      if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('mobile-drawer');
      if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
      triggerState(false);
      drawer.hidden = true;
      overlay.hidden = true;
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      resetDrawer();
    }

    overlay.addEventListener('click', function () {
      setOpen(false);
    });

    // Lightweight touch handling: keep native vertical scrolling and iOS gestures.
    // Both horizontal directions dismiss; movement must clearly exceed vertical drift.
    var swipeStart = null;
    drawer.addEventListener('touchstart', function (event) {
      if (!root.classList.contains('vsklo-mobile-drawer-open') ||
          !event.touches || event.touches.length !== 1) {
        swipeStart = null;
        return;
      }
      var target = event.target;
      if (target && target.closest &&
          target.closest('input, textarea, select, [contenteditable="true"], [data-vsklo-no-swipe]')) {
        swipeStart = null;
        return;
      }
      var touch = event.touches[0];
      swipeStart = {
        identifier: touch.identifier,
        x: touch.clientX,
        y: touch.clientY,
        at: Date.now()
      };
    }, { passive: true });

    drawer.addEventListener('touchend', function (event) {
      if (!swipeStart || !root.classList.contains('vsklo-mobile-drawer-open')) return;
      var start = swipeStart;
      swipeStart = null;
      var changed = event.changedTouches || [];
      for (var index = 0; index < changed.length; index++) {
        var touch = changed[index];
        if (touch.identifier !== start.identifier) continue;
        var distanceX = touch.clientX - start.x;
        var distanceY = touch.clientY - start.y;
        if (Math.abs(distanceX) >= 88 &&
            Math.abs(distanceX) > Math.abs(distanceY) * 1.5 &&
            Date.now() - start.at <= 1200) {
          setOpen(false);
        }
        break;
      }
    }, { passive: true });

    drawer.addEventListener('touchcancel', function () {
      swipeStart = null;
    }, { passive: true });

    prepareClosedState();

    function viewportChanged() {
      if (!drawerViewport()) {
        window.clearTimeout(closeTimer);
        root.classList.remove('vsklo-mobile-drawer-open');
        if (window.VSKLOOverlayState) window.VSKLOOverlayState.release('mobile-drawer');
        if (window.VSKLOCleanupSharedDrawerShell) window.VSKLOCleanupSharedDrawerShell();
        triggerState(false);
        lastTrigger = null;
        finalizeClosed();
      } else if (!root.classList.contains('vsklo-mobile-drawer-open')) {
        prepareClosedState();
      } else {
        syncTop();
      }
    }

    var openApi = function (trigger) {
      setOpen(true, trigger);
    };
    var closeApi = function () {
      setOpen(false);
    };

    drawer.__vskloCanonicalCleanup = function () {
      if (window.VSKLOMobileDrawerSetOpen === setOpen) window.VSKLOMobileDrawerSetOpen = undefined;
      if (window.VSKLOMobileDrawerOpen === openApi) window.VSKLOMobileDrawerOpen = undefined;
      if (window.VSKLOMobileDrawerClose === closeApi) window.VSKLOMobileDrawerClose = undefined;
      if (window.VSKLOMobileDrawerViewportChanged === viewportChanged) window.VSKLOMobileDrawerViewportChanged = undefined;
      delete drawer.__vskloCanonicalCleanup;
    };

    window.VSKLOMobileDrawerSetOpen = setOpen;
    window.VSKLOMobileDrawerOpen = openApi;
    window.VSKLOMobileDrawerClose = closeApi;
    window.VSKLOMobileDrawerViewportChanged = viewportChanged;
    window.__VSKLO_MOBILE_DRAWER_RUNTIME_READY__ = true;
  }

  window.VSKLOInitMobileDrawer = init;
  bindGlobalEvents();

  document.addEventListener('shopify:section:load', function () {
    init();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event && event.target;
    if (!boundDrawer || !scope) return;
    if (boundDrawer === scope || (scope.contains && scope.contains(boundDrawer))) {
      cleanupDetachedBinding();
    }
  });

  document.addEventListener('vsklo:content-updated', function () {
    if (boundDrawer && !boundDrawer.isConnected) cleanupDetachedBinding();
    if (!boundDrawer || !boundDrawer.isConnected) init();
  });

  window.addEventListener('pageshow', function (event) {
    if (!event || !event.persisted) return;
    if (typeof window.VSKLOMobileDrawerClose === 'function') {
      window.VSKLOMobileDrawerClose();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();